export default "__VITE_ASSET__88a15eaa__"